export const copyTextUrl = async ({
  type,
  url,
  expireDate,
  passwd,
  onlyUrl,
}: {
  type: 'customer' | 'external';
  url: string;
  expireDate?: string;
  passwd?: string;
  onlyUrl?: boolean;
}) => {
  const templateTextCustomer = `
    아래 “마크애니 보안링크”를 클릭 후 다운로드 해주세요.
    마크애니 보안링크 : ${url}
    다운로드 만료일 : ${expireDate}
    ${passwd ? `패스워드 : ${passwd}` : ''}
    `.replace(/^\s+/gm, '');

  const templateTextExternal = `
    아래 “마크애니 보안링크”를 클릭 후 다운로드 해주세요.
    마크애니 보안링크 : ${url}
    `.replace(/^\s+/gm, '');

  const templateTextCustomerOnlyUrl = `
    ${url}
    `.replace(/^\s+/gm, '');

  const templateTextExternalOnlyUrl = `
    ${url}
    `.replace(/^\s+/gm, '');

  try {
    await navigator.clipboard.writeText(
      onlyUrl
      ? type === 'customer' ? templateTextCustomerOnlyUrl : templateTextExternalOnlyUrl
      : type === 'customer' ? templateTextCustomer : templateTextExternal
    );
    return true;
  } catch (e) {
    return false;
  }
};
